// extracted by mini-css-extract-plugin
module.exports = {"foundPoliciesWrapper":"found-policies-screen_foundPoliciesWrapper__N_P7E","copyContainer":"found-policies-screen_copyContainer__yEkT4","title":"found-policies-screen_title__aqp5_"};